const FETCH_CUSTOMERS_STARTED = "FETCH_CUSTOMERS_STARTED";

const FETCH_SETTINGS_STARTED = "FETCH_SETTINGS_STARTED";
const FETCH_INVENTORY_STARTED = "FETCH_INVENTORY_STARTED";
const SEARCH_INVENTORY_STARTED = "SEARCH_INVENTORY_STARTED";
const SEARCH_CUSTOMERS_STARTED = "SEARCH_CUSTOMERS_STARTED";
const SEARCH_INVOICES_STARTED = "SEARCH_INVOICES_STARTED";
const FETCH_DRAFTS_STARTED = "FETCH_DRAFTS_STARTED";
const SEARCH_DRAFTS_STARTED = "SEARCH_DRAFTS_STARTED";
const FETCH_SINGLE_CUSTOMER_STARTED = "FETCH_SINGLE_CUSTOMER_STARTED";

// INVOICE
const GET_OVERVIEW_SUCCESS = "GET_OVERVIEW_SUCCESS";
const GET_OVERVIEW_FAILED = "GET_OVERVIEW_FAILED";

const GET_OVERVIEW_DATE_RANGE_SUCCESS = "GET_OVERVIEW_DATE_RANGE_SUCCESS";
const GET_OVERVIEW_DATE_RANGE_FAILED = "GET_OVERVIEW_DATE_RANGE_FAILED";
const GET_OVERVIEW_DATE_RANGE_LOADING = "GET_OVERVIEW_DATE_RANGE_LOADING";

const ADD_INVOICE_SUCCEEDED = "ADD_INVOICE_SUCCEEDED";
const ADD_INVOICE_FAILED = "ADD_INVOICE_FAILED";
const RESET_ADD_INVOICE_STATE = "RESET_ADD_INVOICE_STATE";

const UPDATE_INVOICE_SUCCEEDED = "UPDATE_INVOICE_SUCCEEDED";
const UPDATE_INVOICE_FAILED = "UPDATE_INVOICE_FAILED";
const RESET_UPDATE_INVOICE_STATE = "RESET_UPDATE_INVOICE_STATE";

const SEND_INVOICE_SUCCEEDED = "SEND_INVOICE_SUCCEEDED";
const SEND_INVOICE_FAILED = "SEND_INVOICE_FAILED";
const RESET_SEND_INVOICE_STATE = "RESET_SEND_INVOICE_STATE";

const EDIT_INVOICE_SUCCEEDED = "EDIT_INVOICE_SUCCEEDED";
const EDIT_INVOICE_FAILED = "EDIT_INVOICE_FAILED";
const RESET_EDIT_INVOICE_STATE = "RESET_EDIT_INVOICE_STATE";

export const FETCH_INVOICES_STARTED = "FETCH_INVOICES_STARTED";
export const FETCH_INVOICES_SUCCEEDED = "FETCH_INVOICES_SUCCEEDED";
export const FETCH_INVOICES_FAILED = "FETCH_INVOICES_FAILED";

const SEARCH_INVOICES_SUCCEEDED = "SEARCH_INVOICES_SUCCEEDED";
const SEARCH_INVOICES_FAILED = "SEARCH_INVOICES_FAILED";
const RESET_SEARCH_INVOICES = "R    ESET_SEARCH_INVOICES";

export const GET_INVOICE_STATUS_STARTED = "GET_INVOICE_STATUS_STARTED";
export const GET_INVOICE_STATUS_SUCCEEDED = "GET_INVOICE_STATUS_SUCCEEDED";
export const GET_INVOICE_STATUS_FAILED = "GET_INVOICE_STATUS_FAILED";
// INVOICE DRAFTS

const CREATE_INVOICE_DRAFT_SUCCEEDED = "CREATE_INVOICE_DRAFT_SUCCEEDED";
const CREATE_INVOICE_DRAFT_FAILED = "CREATE_INVOICE_DRAFT_FAILED";
const RESET_CREATE_INVOICE_DRAFT_STATE = "RESET_CREATE_INVOICE_DRAFT_STATE";

const UPDATE_INVOICE_DRAFT_SUCCEEDED = "UPDATE_INVOICE_DRAFT_SUCCEEDED";
const UPDATE_INVOICE_DRAFT_FAILED = "UPDATE_INVOICE_DRAFT_FAILED";
const RESET_UPDATE_INVOICE_DRAFT_STATE = "RESET_UPDATE_INVOICE_DRAFT_STATE";

const SEARCH_INVOICE_DRAFT_SUCCEEDED = "SEARCH_INVOICE_DRAFT_SUCCEEDED";
const SEARCH_INVOICE_DRAFT_FAILED = "SEARCH_INVOICE_DRAFT_FAILED";
const RESET_SEARCH_INVOICE_DRAFT_STATE = "RESET_SEARCH_INVOICE_DRAFT_STATE";
const SEARCH_INVOICE_DRAFT_STARTED = "SEARCH_INVOICE_DRAFT_STARTED";

const DELETE_INVOICE_DRAFT_SUCCEEDED = "DELETE_INVOICE_DRAFT_SUCCEEDED";
const DELETE_INVOICE_DRAFT_FAILED = "DELETE_INVOICE_DRAFT_FAILED";
const RESET_DELETE_INVOICE_DRAFT_STATE = "RESET_DELETE_INVOICE_DRAFT_STATE";

const FETCH_INVOICE_DRAFT_STARTED = "FETCH_INVOICE_DRAFT_STARTED";
const FETCH_INVOICE_DRAFT_SUCCEEDED = "FETCH_INVOICE_DRAFT_SUCCEEDED";
const FETCH_INVOICE_DRAFT_FAILED = "FETCH_INVOICE_DRAFT_FAILED";
const RESET_FETCH_INVOICE_DRAFT_STATE = "RESET_FETCH_INVOICE_DRAFT_STATE";

const FETCH_ALL_INVOICE_DRAFTS_SUCCEEDED = "FETCH_ALL_INVOICE_DRAFTS_SUCCEEDED";
const FETCH_ALL_INVOICE_DRAFTS_FAILED = "FETCH_ALL_INVOICE_DRAFTS_FAILED";
const RESET_FETCH_ALL_INVOICE_DRAFTS_STATE = "RESET_FETCH_ALL_INVOICE_DRAFTS_STATE";

// SINGLE INVOICE / EDIT INVOICE
const FETCH_SINGLE_INVOICE_STARTED = "FETCH_SINGLE_INVOICE_STARTED";
const FETCH_SINGLE_INVOICE_SUCCESS = "FETCH_SINGLE_INVOICE_SUCCESS";
const FETCH_SINGLE_INVOICE_FAILED = "FETCH_SINGLE_INVOICE_FAILED";

// INVOICE PREVIEW
const FETCH_INVOICE_DETAILS_STARTED = "FETCH_INVOICE_DETAILS_STARTED";
const FETCH_INVOICE_DETAILS_SUCCESS = "FETCH_INVOICE_DETAILS_SUCCESS";
const FETCH_INVOICE_DETAILS_FAILED = "FETCH_INVOICE_DETAILS_FAILED";

// SETTINGS
const ADD_SETTINGS_SUCCEEDED = "ADD_SETTINGS_SUCCEEDED";
const ADD_SETTINGS_FAILED = "ADD_SETTINGS_FAILED";
const RESET_ADD_SETTINGS_STATE = "RESET_ADD_SETTINGS_STATE";

const EDIT_SETTINGS_SUCCEEDED = "EDIT_SETTINGS_SUCCEEDED";
const EDIT_SETTINGS_FAILED = "EDIT_SETTINGS_FAILED";
const RESET_EDIT_SETTINGS_STATE = "RESET_EDIT_SETTINGS_STATE";

const FETCH_SETTINGS_SUCCEEDED = "FETCH_SETTINGS_SUCCEEDED";
const FETCH_SETTINGS_FAILED = "FETCH_SETTINGS_FAILED";

export const GET_SETTINGS_STARTED = "GET_SETTINGS_STARTED";
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_FAILED = "GET_SETTINGS_FAILED";
// CUSTOMER / CLIENTS
const ADD_CUSTOMER_SUCCEEDED = "ADD_CUSTOMER_SUCCEEDED";
const ADD_CUSTOMER_FAILED = "ADD_CUSTOMER_FAILED";
const RESET_ADD_CUSTOMER_STATE = "RESET_ADD_CUSTOMER_STATE";
const RESET_CUSTOMERS = "RESET_CUSTOMERS";

const EDIT_CUSTOMER_SUCCEEDED = "EDIT_CUSTOMER_SUCCEEDED";
const EDIT_CUSTOMER_FAILED = "EDIT_CUSTOMER_FAILED";
const RESET_EDIT_CUSTOMER_STATE = "RESET_EDIT_CUSTOMER_STATE";

const DELETE_CUSTOMER_STARTED = "DELETE_CUSTOMER_STARTED";
const DELETE_CUSTOMER_SUCCEEDED = "DELETE_CUSTOMER_SUCCEEDED";
const DELETE_CUSTOMER_FAILED = "DELETE_CUSTOMER_FAILED";
const RESET_DELETE_CUSTOMER_STATE = "RESET_DELETE_CUSTOMER_STATE";

const FETCH_SINGLE_CUSTOMER_SUCCEEDED = "FETCH_SINGLE_CUSTOMER_SUCCEEDED";
const FETCH_SINGLE_CUSTOMER_FAILED = "FETCH_SINGLE_CUSTOMER_FAILED";
const RESET_FETCH_SINGLE_CUSTOMER = "RESET_FETCH_SINGLE_CUSTOMER";

const FETCH_CUSTOMERS_SUCCEEDED = "FETCH_CUSTOMERS_SUCCEEDED";
const FETCH_CUSTOMERS_FAILED = "FETCH_CUSTOMERS_FAILED";

const SEARCH_CUSTOMERS_SUCCEEDED = "SEARCH_CUSTOMERS_SUCCEEDED";
const SEARCH_CUSTOMERS_FAILED = "SEARCH_CUSTOMERS_FAILED";
const RESET_SEARCH_CUSTOMERS = "RESET_SEARCH_CUSTOMERS";

// INVENTORY
const ADD_INVENTORY_SUCCEEDED = "ADD_INVENTORY_SUCCEEDED";
const ADD_INVENTORY_FAILED = "ADD_INVENTORY_FAILED";
const RESET_ADD_INVENTORY_STATE = "RESET_ADD_INVENTORY_STATE";
const RESET_INVENTORY = "RESET_INVENTORY";

const EDIT_INVENTORY_SUCCEEDED = "EDIT_INVENTORY_SUCCEEDED";
const EDIT_INVENTORY_FAILED = "EDIT_INVENTORY_FAILED";
const RESET_EDIT_INVENTORY_STATE = "RESET_EDIT_INVENTORY_STATE";

const DELETE_INVENTORY_STARTED = "DELETE_INVENTORY_STARTED";
const DELETE_INVENTORY_SUCCEEDED = "DELETE_INVENTORY_SUCCEEDED";
const DELETE_INVENTORY_FAILED = "DELETE_INVENTORY_FAILED";
const RESET_DELETE_INVENTORY_STATE = "RESET_DELETE_INVENTORY_STATE";

const FETCH_INVENTORY_SUCCEEDED = "FETCH_INVENTORY_SUCCEEDED";
const FETCH_INVENTORY_FAILED = "FETCH_INVENTORY_FAILED";

const SEARCH_INVENTORY_SUCCEEDED = "SEARCH_INVENTORY_SUCCEEDED";
const SEARCH_INVENTORY_FAILED = "SEARCH_INVENTORY_FAILED";
const RESET_SEARCH_INVENTORY = "RESET_SEARCH_INVENTORY";
const RESET_INVOICES = "RESET_INVOICES";

// PAYMENT AND REMINDERS

const SETTLE_MANUALLY_SUCCEEDED = "SETTLE_MANUALLY_SUCCEEDED";
const SETTLE_MANUALLY_FAILED = "SETTLE_MANUALLY_FAILED";
const RESET_SETTLE_MANUALLY = "RESET_SETTLE_MANUALLY";

const SEND_REMINDER_SUCCEEDED = "SEND_REMINDER_SUCCEEDED";
const SEND_REMINDER_FAILED = "SEND_REMINDER_FAILED";
const RESET_SEND_REMINDER = "RESET_SEND_REMINDER";

// ESTIMATES
const FETCH_INVOICE_ESTIMATE_STARTED = "FETCH_INVOICE_ESTIMATE_STARTED";
const FETCH_INVOICE_ESTIMATE_SUCCEEDED = "FETCH_INVOICE_ESTIMATE_SUCCEEDED";
const FETCH_INVOICE_ESTIMATE_FAILED = "FETCH_INVOICE_ESTIMATE_FAILED";
const RESET_FETCH_INVOICE_ESTIMATE_STATE = "RESET_FETCH_INVOICE_ESTIMATE_STATE";

export {
    GET_OVERVIEW_SUCCESS,
    GET_OVERVIEW_FAILED,
    GET_OVERVIEW_DATE_RANGE_SUCCESS,
    GET_OVERVIEW_DATE_RANGE_LOADING,
    GET_OVERVIEW_DATE_RANGE_FAILED,
    ADD_INVOICE_SUCCEEDED,
    ADD_INVOICE_FAILED,
    RESET_ADD_INVOICE_STATE,
    UPDATE_INVOICE_SUCCEEDED,
    UPDATE_INVOICE_FAILED,
    RESET_UPDATE_INVOICE_STATE,
    EDIT_INVOICE_SUCCEEDED,
    EDIT_INVOICE_FAILED,
    RESET_EDIT_INVOICE_STATE,
    FETCH_CUSTOMERS_STARTED,
    FETCH_INVENTORY_STARTED,
    ADD_CUSTOMER_SUCCEEDED,
    ADD_CUSTOMER_FAILED,
    FETCH_CUSTOMERS_SUCCEEDED,
    FETCH_CUSTOMERS_FAILED,
    RESET_ADD_CUSTOMER_STATE,
    DELETE_CUSTOMER_STARTED,
    DELETE_CUSTOMER_SUCCEEDED,
    DELETE_CUSTOMER_FAILED,
    RESET_DELETE_CUSTOMER_STATE,
    EDIT_CUSTOMER_SUCCEEDED,
    EDIT_CUSTOMER_FAILED,
    RESET_EDIT_CUSTOMER_STATE,
    ADD_INVENTORY_SUCCEEDED,
    ADD_INVENTORY_FAILED,
    RESET_ADD_INVENTORY_STATE,
    EDIT_INVENTORY_SUCCEEDED,
    EDIT_INVENTORY_FAILED,
    RESET_EDIT_INVENTORY_STATE,
    DELETE_INVENTORY_STARTED,
    DELETE_INVENTORY_SUCCEEDED,
    DELETE_INVENTORY_FAILED,
    RESET_DELETE_INVENTORY_STATE,
    FETCH_INVENTORY_SUCCEEDED,
    FETCH_INVENTORY_FAILED,
    FETCH_SETTINGS_STARTED,
    ADD_SETTINGS_SUCCEEDED,
    ADD_SETTINGS_FAILED,
    RESET_ADD_SETTINGS_STATE,
    EDIT_SETTINGS_SUCCEEDED,
    EDIT_SETTINGS_FAILED,
    RESET_EDIT_SETTINGS_STATE,
    FETCH_SETTINGS_SUCCEEDED,
    FETCH_SETTINGS_FAILED,
    SEND_INVOICE_SUCCEEDED,
    SEND_INVOICE_FAILED,
    RESET_SEND_INVOICE_STATE,
    RESET_INVENTORY,
    SEARCH_INVENTORY_SUCCEEDED,
    SEARCH_INVENTORY_FAILED,
    SEARCH_INVENTORY_STARTED,
    RESET_SEARCH_INVENTORY,
    RESET_CUSTOMERS,
    SEARCH_CUSTOMERS_SUCCEEDED,
    SEARCH_CUSTOMERS_FAILED,
    RESET_SEARCH_CUSTOMERS,
    SEARCH_CUSTOMERS_STARTED,
    SEARCH_INVOICES_STARTED,
    SEARCH_INVOICES_SUCCEEDED,
    SEARCH_INVOICES_FAILED,
    RESET_SEARCH_INVOICES,
    RESET_INVOICES,
    FETCH_INVOICE_DETAILS_STARTED,
    FETCH_INVOICE_DETAILS_SUCCESS,
    FETCH_INVOICE_DETAILS_FAILED,
    FETCH_SINGLE_INVOICE_STARTED,
    FETCH_SINGLE_INVOICE_SUCCESS,
    FETCH_SINGLE_INVOICE_FAILED,
    FETCH_DRAFTS_STARTED,
    SEARCH_DRAFTS_STARTED,
    CREATE_INVOICE_DRAFT_SUCCEEDED,
    CREATE_INVOICE_DRAFT_FAILED,
    RESET_CREATE_INVOICE_DRAFT_STATE,
    UPDATE_INVOICE_DRAFT_SUCCEEDED,
    UPDATE_INVOICE_DRAFT_FAILED,
    RESET_UPDATE_INVOICE_DRAFT_STATE,
    SEARCH_INVOICE_DRAFT_STARTED,
    SEARCH_INVOICE_DRAFT_SUCCEEDED,
    SEARCH_INVOICE_DRAFT_FAILED,
    RESET_SEARCH_INVOICE_DRAFT_STATE,
    DELETE_INVOICE_DRAFT_SUCCEEDED,
    DELETE_INVOICE_DRAFT_FAILED,
    RESET_DELETE_INVOICE_DRAFT_STATE,
    FETCH_INVOICE_DRAFT_STARTED,
    FETCH_INVOICE_DRAFT_SUCCEEDED,
    FETCH_INVOICE_DRAFT_FAILED,
    RESET_FETCH_INVOICE_DRAFT_STATE,
    FETCH_ALL_INVOICE_DRAFTS_SUCCEEDED,
    FETCH_ALL_INVOICE_DRAFTS_FAILED,
    RESET_FETCH_ALL_INVOICE_DRAFTS_STATE,
    SETTLE_MANUALLY_FAILED,
    SETTLE_MANUALLY_SUCCEEDED,
    SEND_REMINDER_FAILED,
    SEND_REMINDER_SUCCEEDED,
    RESET_SEND_REMINDER,
    RESET_SETTLE_MANUALLY,
    FETCH_SINGLE_CUSTOMER_FAILED,
    FETCH_SINGLE_CUSTOMER_STARTED,
    FETCH_SINGLE_CUSTOMER_SUCCEEDED,
    RESET_FETCH_SINGLE_CUSTOMER,
    //estimates
    FETCH_INVOICE_ESTIMATE_STARTED,
    FETCH_INVOICE_ESTIMATE_SUCCEEDED,
    FETCH_INVOICE_ESTIMATE_FAILED,
    RESET_FETCH_INVOICE_ESTIMATE_STATE,
};
